/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module PresentationRules
 */

import { ConditionContainer, RuleBase, RuleTypes } from "../Rule";
import { ContentSpecification } from "./ContentSpecification";

/**
 * Defines content that's displayed in content controls (table view,
 * property pane, etc.) and the content that's selected in
 * [unified selection]($docs/learning/presentation/unified-selection/index.md) controls
 *
 * @see [More details]($docs/learning/presentation/Content/ContentRule.md)
 * @public
 */
export interface ContentRule extends RuleBase, ConditionContainer {
  /** Used for serializing to JSON. */
  ruleType: RuleTypes.Content;

  /**
   * Defines a condition for the rule, which needs to be met in order to execute it. Condition
   * is an [ECExpression]($docs/learning/presentation/ECExpressions.md), which can use
   * a [limited set of symbols]($docs/learning/presentation/Content/ECExpressions.md#rule-condition).
   */
  condition?: string;

  /** Specifications that define content returned by the rule */
  specifications: ContentSpecification[];
}
